import { AuthProvider, SignInEmailPage } from '@hub-la/fe-auth'

export const SignInEmailInit = () => {
  return (
    <AuthProvider>
      <SignInEmailPage />
    </AuthProvider>
  )
}
